import * as React from 'react';

interface SideBySideProps {
  LeftComponent: React.ReactElement
  RightComponent: React.ReactElement
  AsRow?: boolean
}

export default function SideBySideView(props: SideBySideProps) {
  const style: React.CSSProperties = props.AsRow ? { display: 'flex', flexGrow: 1, flexDirection: 'row', alignItems: 'center' } : { flexGrow: 1 };
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', columnGap: '20px' }}>
      <div style={style}>{props.LeftComponent}</div>
      <div style={style}>{props.RightComponent}</div>
    </div>
  );
}
